import { Categorias } from './../../classes/categorias';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css'],
  standalone: false,
})
export class CategoryComponent {
  @Input() category: Categorias;

  constructor(private router: Router) {}

  redirectTag() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/tag'], {
        queryParams: { s: encodeURI(this.category.url) },
      });
    });
  }
}
